import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import { ViewStyle } from 'react-native'

import { useTheme } from 'styled-components/native'

import { BaseButton, ButtonType } from '../../atoms/baseButton/BaseButton'
import { IconButton } from '../../atoms/iconButton/IconButton'
import { GroupAddIcon } from '../../atoms/icons/GroupAddIcon'
import { AuroraIconCircle } from '../../organisms/lightHomeToolbar/utils'
import { tID } from '../../utils/utils'

export interface ReferButtonProps {
  onPress: () => void
}

export const ReferButton: FunctionComponent<ReferButtonProps> = ({ onPress }) => {
  const {
    breakpoints: { isMobileSized },
    colors,
    isAuroraTheme,
  } = useTheme()
  const { formatMessage } = useIntl()
  const referText = formatMessage({
    defaultMessage: 'Refer',
    description: 'Button for referral',
  })

  const mobileIconWFMHStyle: ViewStyle = { width: 24, height: 24, marginRight: 8, alignSelf: 'center' }

  const mobileIconAuroraStyle: ViewStyle = { width: 24, height: 24, alignSelf: 'center', padding: 24 }

  const defaultMobileIconButton = (style: ViewStyle) => {
    return (
      <IconButton
        accessibilityLabel={referText}
        onPress={onPress}
        iconColor={colors.secondaryButtonTextActive}
        leftIcon={<GroupAddIcon fillColor={colors.secondaryButtonTextActive} width={24} />}
        style={style}
        testID={tID('Refer-button')}
      />
    )
  }

  const getMobileIconButton = () => {
    return isAuroraTheme ? (
      <AuroraIconCircle>{defaultMobileIconButton(mobileIconAuroraStyle)}</AuroraIconCircle>
    ) : (
      defaultMobileIconButton(mobileIconWFMHStyle)
    )
  }

  return isMobileSized ? (
    getMobileIconButton()
  ) : (
    <BaseButton
      buttonType={ButtonType.SECONDARY}
      text={referText}
      accessibilityLabel={referText}
      leftIcon={<GroupAddIcon fillColor={colors.secondaryButtonTextActive} width={24} />}
      onPress={onPress}
      testID={tID('Refer-button')}
    />
  )
}
